import React, { useEffect } from 'react'

import User from '@js/common/user'
import { getTestParam } from '@js/common/utils'

import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

const BauortModal = props => {
  const close = () => {
    _wt({
      category: 'modal',
      action: 'hide',
      values: [
        {
          type: 'name',
          value: 'bauort-header'
        }
      ]
    })

    props.closeModal()
  }

  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'bauort-header'
        }
      ]
    })
  }, [])

  return (
    <div className='RequestWizard-wrapper'>
      <div className='RequestWizard'>
        <div className='RequestWizard-form-wrapper'>
          <div className='RequestWizard-top is-location'>
            <div className='RequestWizard-heading'>
              <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
                Ihren Bauort anpassen
              </div>
            </div>

            <div className='RequestWizard-content'>
              <div data-sel='ipt-bo'>
                <LocationFinder
                  onChange={User.setLocation}
                  className='[ f-t-left ]'
                />
              </div>
            </div>
          </div>
          <div className='RequestWizard-bottom'>
            <CTA
              type='block-primary'
              className='[ f-m-h-auto f-m-t-020 ] is-block:s'
              tag='button'
              onClick={close}>
              Fertig
            </CTA>
          </div>
        </div>
        <CTA
          type='icon'
          tag='button'
          className='Modal-top-button Modal-top-button-close'
          onClick={close}
          data-sel='btn-cls'>
          <Icon icon='close-16px' className='[ f-icon-030 f-c-st-bla ]' />
        </CTA>
        <CTA
          type='icon'
          tag='button'
          className='Modal-top-button Modal-top-button-close'
          onClick={close}>
          <Icon icon='close-16px' className='[ f-icon-030 f-c-st-bla ]' />
        </CTA>
      </div>
    </div>
  )
}

export default BauortModal
